import { ValidatedResource } from './validated-resource';

export class CardType extends ValidatedResource {
  bin: string;
  type: 'credit' | 'debit';
}
